export default "__VITE_ASSET__BQPkyPH3__"